import sha256 from "crypto-js/sha256";

const FAN_USERNAME_HASHES = new Set([
  "825843c8cc9423e61b1a5270fb0c1ce60ade092697842ac1f48a6e1ce1506ecd",
  "784d5299fad883d168d8e39f458d077f5218358f01989bf7bb65028b072c7761",
  "563436c453205021fe55ed1c891e8f3c1e9591a81eea2bd69af0335d872392db",
  "5ce6104655097a2398f04eac8cd7020e940fcc4e61e39ad5dedc6909a8754eb3",
  "fc03c222be29e2529e4d46d42c01d1daabd5f1da3e8c7543d66eec612d0746f4",
  "0650064535c696c28d2d33c28331e1a69ec1e1dc0dcb11f54d02449e18ea8e3f",
  "f7db2b7a820f77ad4744e00f243c7746dbc80b5a095209edb45e353e2d62eed6",
  "1674efa419039f171b94cf6c44cd76daa0b765c10c59b6b8bb3432c3292ff0c1",
  "a21148c967068450f9d6fd7d07ef03899a563589a13fa2d5ab9818719dbe88f7",
  "915857b8ea5d2e525128ffd942f2e68a0d93600f26676fd0bae1e17a3a4be27f",
  "9a514b0a473bfb2e00bd313b728a4ff3c49b53285cc19fa53a0c539bf4d5ee97",
  "6c0b0850038f7937ff5b0c7fa4bfdac0854df42bdb0f6c5ceb6fb8202cc45ef6",
  "c3777cf3d2545ae8371db413ce13c420f62b1c48e13a47ffacaa2c803b7cd7a8",
  "f7bfd9a7dbaca5c313e3a06c4300a6e7d5b87ae27bd9ee34d8dd4676bc23dcdb",
  "1d0ffa442e9fc02893f92cf4fc59ad9f4ab051158548a44e016be2718088bb8e",
  "1dec5acf22e54074376f76a9f51df7bffff5660bfb2ec70e334885a7e7b8d27b",
  "76b55520ba705632892a5957453df69249231613038a85cb67128236a121984c",
]);

export function isFenerbahceFan(username: string | null | undefined): boolean {
  if (!username) return false;
  const normalized = username.trim().toLowerCase();
  return FAN_USERNAME_HASHES.has(sha256(normalized).toString());
}
